export default "__VITE_ASSET__e5cF8pzH__"